import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, Gear } from '@phosphor-icons/react';

export const MasterAdminPanel = () => {
  const navigate = useNavigate();

  return (
    <div data-testid="master-admin-panel" className="bg-gradient-to-r from-[#0096FF]/10 to-[#00D4FF]/5 border border-[#0096FF]/30 rounded-lg p-5 sm:p-8 mb-8">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#0096FF]/20 rounded-lg flex items-center justify-center">
          <span className="text-[#0096FF] text-xl sm:text-2xl font-black">M</span>
        </div>
        <div>
          <h2 className="text-lg sm:text-2xl font-bold text-white" style={{fontFamily: 'Outfit'}}>Master Admin Access</h2>
          <p className="text-[#9E9E9E] text-xs sm:text-sm hidden sm:block">Full platform control - manage all shows, users, and organizations</p>
        </div>
      </div>
      <div className="flex flex-wrap gap-2 sm:gap-3">
        <button
          data-testid="master-create-show-btn"
          onClick={() => navigate('/shows/create')}
          className="inline-flex items-center gap-2 px-4 sm:px-6 py-2.5 sm:py-3 bg-[#0096FF] hover:bg-[#00D4FF] text-white font-semibold rounded-md transition-colors text-sm"
        >
          <Plus size={18} weight="bold" />
          Create Show
        </button>
        <button
          data-testid="master-manage-orgs-btn"
          onClick={() => navigate('/organization/setup')}
          className="inline-flex items-center gap-2 px-4 sm:px-6 py-2.5 sm:py-3 bg-transparent border border-[#0096FF] hover:bg-[#0096FF]/10 text-[#0096FF] font-semibold rounded-md transition-colors text-sm"
        >
          Organizations
        </button>
        <button
          data-testid="master-manage-subscriptions-btn"
          onClick={() => navigate('/subscriptions')}
          className="inline-flex items-center gap-2 px-4 sm:px-6 py-2.5 sm:py-3 bg-transparent border border-[#00D4FF] hover:bg-[#00D4FF]/10 text-[#00D4FF] font-semibold rounded-md transition-colors text-sm"
        >
          Subscriptions
        </button>
        <button
          data-testid="master-platform-settings-btn"
          onClick={() => navigate('/admin/platform-settings')}
          className="inline-flex items-center gap-2 px-4 sm:px-6 py-2.5 sm:py-3 bg-transparent border border-[#FF9500] hover:bg-[#FF9500]/10 text-[#FF9500] font-semibold rounded-md transition-colors text-sm"
        >
          <Gear size={18} weight="bold" />
          Platform Settings
        </button>
      </div>
    </div>
  );
};
